import "./app.scss";

import Register from "./pages/register/Register";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<Register />} />
      </Routes>
    </Router>
  );
};

export default App;
